import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const BundlesHub = lazy(() => import('../components/bundles/pages/HubPage'));
const BundlesCatalog = lazy(() => import('../components/bundles/pages/CatalogPage'));
const BundlesRequired = lazy(() => import('../components/bundles/pages/RequiredPage'));
const BundlesCreate = lazy(() => import('../components/bundles/pages/CreatePage'));
const BundlesEdit = lazy(() => import('../components/bundles/pages/EditPage'));
const BundlesCollate = lazy(() => import('../components/bundles/pages/CollatePage'));
const BundlesCollationOps = lazy(() => import('../components/bundles/pages/CollationOpsPage'));
const BundlesRundown = lazy(() => import('../components/bundles/pages/RundownPage'));
const BundlesEconomics = lazy(() => import('../components/bundles/pages/EconomicsPage'));
const BundlesBulkUpload = lazy(() => import('../components/bundles/pages/BulkUploadPage'));

export const bundlesRoutes = (
  <>
    <Route path="/bundles" element={<BundlesHub />} />
    <Route path="/bundles/catalog" element={<BundlesCatalog />} />
    <Route path="/bundles/required" element={<BundlesRequired />} />
    <Route path="/bundles/create" element={<BundlesCreate />} />
    <Route path="/bundles/edit" element={<BundlesEdit />} />
    <Route path="/bundles/collate" element={<BundlesCollate />} />
    <Route path="/bundles/collation-operations" element={<BundlesCollationOps />} />
    <Route path="/bundles/collation-operations/:opId" element={<BundlesCollationOps />} />
    <Route path="/bundles/bulk-upload" element={<BundlesBulkUpload />} />
    <Route path="/bundles/:bundleSku" element={<BundlesRundown />} />
    <Route path="/bundles/:bundleSku/economics" element={<BundlesEconomics />} />
  </>
);
